function NotFound() {

  return (
    <section className='welcome-page contain align-middle'>
      <h1>
        404
      </h1>
      <p>
        The page is not found.
      </p>
      <div className="row">
        <div>
          <a href="/create" className='btn'>Create Content</a>
        </div>
      </div>
    </section>
  );
}

export default NotFound;